import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { IRendererConfigurationDefinition } from '@wix/viewer-service-renderer-configuration/definition'
import { RendererConfigurationDefinition as definition } from '@wix/viewer-service-renderer-configuration/definition'
import { RendererConfigurationService as impl } from '@wix/viewer-service-renderer-configuration/implementations'
import { name } from './symbols'
import type { RendererConfigurationSiteConfig } from './types'

export const RendererConfigurationService = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(config: RendererConfigurationSiteConfig): ServiceProvider<IRendererConfigurationDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config,
		}
	}
)
